<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">

    <div class="flex" style="margin-top: .1563rem;width: 1.3438rem;">
      <img src="../../assets/SsendHead.png" style="width: .0625rem;height: .0703rem;margin-top: .026rem;" alt="">
      <div class="sendtitle">家长称呼</div>
      <span class="answer">{{ alldata.parentName }}</span>

    </div>
    <!-- <div class="flex" style="margin-top: .0781rem;width: 1.3438rem;">
      <img src="../../assets/TjianliPhone.png" style="width: .0625rem;height: .0703rem;margin-top: .026rem;" alt="">
      <div class="sendtitle">联系方式</div>

      <span class="answer"> {{ this.phone }}</span>
    </div> -->
    <div class="flex" style="margin-top: .0781rem;width: 1.3438rem;">
      <img src="../../assets/SsendSex.png" style="width: .0677rem;height: .0703rem;margin-top: .026rem;" alt="">
      <div class="sendtitle">学生性别</div>
      <div class="answer">{{ alldata.studentGender ? studentgenderList[alldata.studentGender] : '不详' }}</div>
    </div>
    <div style="display: flex; margin-top: .0781rem; width: 1.3438rem;justify-content: space-between;">
      <img src="../../assets/TjianliClass.png" alt=""
        style="transform: translateY(.0156rem);width: .0625rem;height: .0729rem;">
      <div class="sendtitle">上课内容</div>
      <div class="answer">{{ teachitemslist[alldata.itemId] }}</div>
    </div>
    <div class="flex"
      style="justify-content: space-between;margin: 0rem 0 .0833rem 0;width: 1.3438rem; margin-top: .0781rem;">
      <img src="../../assets/SsendLocation.png" alt=""
        style="width: .0573rem;height: .0729rem;transform: translateY(.0208rem);">
      <div class="sendtitle">
        <div>授课区域</div>
      </div>

      <div class="answer">{{ teachAreaslist[studyArea] }}</div>
    </div>
    <div class="flex" style="margin-top: .0781rem;width: 1.80438rem;">
      <img src="../../assets/TjianliSchool.png"
        style="width: .0677rem;height: .0781rem;margin-top: .026rem;transform: translateY(-0.0104rem);" alt="">
      <div class="sendtitle">详细地址</div>
      <div class="answer" style="width: 1.4rem;">{{ alldata.address }}</div>
    </div>
    <div class="flex" style="width: 1.3454rem;margin-top: .0781rem;">
      <img src="../../assets/TjianliTime.png" style="width: .0729rem;height: .0729rem; transform: translateY(.0208rem);"
        alt="">
      <div>
        <div class="sendtitle">授课时间</div>
      </div>
      <div class="answer"><span v-for=" item  in  alldata.studyTimes ">{{ studyTimeslist[item] }}　</span></div>
    </div>
    <div class="flex" style="justify-content: space-between;margin: .0781rem 0 0rem 0;width: 1.6854rem;">
      <img src="../../assets/SsendRicheng.png" alt=""
        style="width: .0729rem;height: .0729rem;transform: translateY(.0156rem);">
      <div class="sendtitle">
        <div>补习日程</div>
      </div>
      <div class="answer" style="width: 1.2rem;">{{ period }}</div>
    </div>
    <div class="flex" style="justify-content: space-between;margin: .0781rem 0 0rem 0;width: 1.4854rem;">
      <img src="../../assets/TjianliMoney.png" alt=""
        style="width: .0729rem;height: .0729rem;transform: translateY(.0156rem);">
      <div class="sendtitle">
        <div>酬金</div>
      </div>
      <div class="answer" style="width: 1rem;">{{ alldata.price }}元/小时</div>
    </div>
    <div class="flex" style="width: .44rem;margin-top: 0.0781rem;"><img src="../../assets/Tjianlixuesheng.png" alt=""
        style="width: .075rem;height: .09rem; transform: translateY(0.01rem); ">
      <div class="sendtitle">
        <div>学生情况</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="msg">{{ alldata.studentLearningSituation }}</div>
    <div class="flex" style="width: .64rem;margin-top: 0.0781rem;"><img src="../../assets/Tjianlilaoshi.png" alt=""
        style="width: .085rem;height: .07rem; transform: translateY(0.02rem); ">
      <div class="sendtitle" style="width: .6rem;">
        <div>对老师的要求</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="msg">{{ alldata.request ? alldata.request : '无' }}</div>
    <div class="flex" style="width: .64rem;margin-top: 0.0781rem;"><img src="../../assets/Tjianliyingxing.png" alt=""
        style="width: .085rem;height: .07rem; transform: translateY(0.02rem); ">
      <div class="sendtitle" style="width: .6rem;">
        <div>硬性要求</div>
      </div>
    </div>
    <div class="flex" style="margin-top: .0781rem;width: 1.5438rem;">
      <div class="sendtitle" style="transform: translateY(-0.02rem);">老师性别</div>
      <!-- <template>
        <el-radio-group v-model="teacherGender" text-color="#606266" style="width: 1.3854rem;">
          <el-radio :label="1">女</el-radio>
          <el-radio :label="0">男</el-radio>
          <el-radio :label="2">不限</el-radio>
        </el-radio-group>
      </template> -->
      <div class="answer" style="width: 1rem;">{{ teacherGenderlist[alldata.teacherGender] }}</div>
    </div>
    <div class="flex" style="justify-content: space-between;margin: .0625rem 0 0rem 0;width: 1.5rem;">
      <div class="sendtitle" style="width: .625rem;">
        <div>老师类型(可多选)</div>
      </div>
      <div class="answer">在校大学生</div>
    </div>
    <div class="flex" style="justify-content: space-between;margin: .0625rem 0 0rem 0;width: 1.2396rem;">
      <div class="sendtitle">
        <div>辅导方式</div>
      </div>
      <div class="answer">在校大学生</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['did'],
  data() {
    return {
      Authorization: '',
      classHours: '',
      fanweichecked: [
        {
          value: [],
        },
      ],
      timeqasd: '',
      teacherClasschecked: '',
      teacherClass: ['在读大学生', '已毕业'],
      teachMethodchecked: '',
      teacherGender: 0,
      studyArea: 0,
      teachitemslist: {
        10: '小学全科',
        11: '小学语文',
        12: '小学奥数',
        13: '小学数学',
        14: '小学英语',
        15: '作业辅导',
        20: '初中全科',
        21: '初中语文',
        22: '初中英语',
        23: '初中数学',
        24: '初中物理',
        25: '初中化学',
        30: '高中数学',
        31: '高中语文',
        32: '高中英语',
        33: '高中物理',
        34: '高中化学',
        35: '高中生物',
        36: '高中历史',
        37: '高中政治',
        38: '高中地理',
        40: '法语',
        41: '德语',
        42: '西班牙语',
        43: '日语',
        44: '葡萄牙语',
        45: '韩语',
        50: '音乐',
        51: '美术',
        52: '舞蹈',
        53: '体育',
        54: '体育',
        60: '其他',
      },
      studyTimeslist: ['周一到周五晚上', '周一到周五全天', '周六上午', '周六下午', '周六晚上', '周日上午', '周日下午', '周日晚上', '寒暑假均可'],

      alldata: {},
      teachAreaslist: ['锦江区', '金牛区', '武侯区', '青羊区', '成华区', '高新区', '天府新区', '新都区', '郫都区', '双流区', '龙泉驿区', '温江区', '其他'],
      teacherGenderlist: {
        0: '男',
        1: '女',
        2: '不限'
      },
      studentgenderList: ['男', '女'],
      period: ''
    }
  },
  methods: {
    submit() {
      for (let key in this.$data) {
        if (this.$data[key] === '' || this.$data[key].length == 0 || this.fanweichecked[0].value.length == 0) {
          console.error(`The ${key} field is empty`);
          this.$message.error('您输入的信息不完整哦~');
          return false;
        }
      }
      this.$router.push('/personteacher/jianlisucces')

    }
  },
  created() {
    console.log(this.did);
    this.Authorization = localStorage.getItem('Authorization')
    this.$http.get('/Api/Teacher/Demand/Verify/' + this.did, {
      headers: {
        'Authorization': this.Authorization,
      }
    }).then(res => {
      this.alldata = res.data.data
      console.log(this.alldata);
      if (this.alldata.period == null) {
        this.period = '未确定'
      }
      else {
        let dates = this.alldata.period.split('-').map(date => new Date(date).toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' }));
        this.period = dates.join('至')
      }
    })
  }

}

</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
  width: auto;
}

.line {
  width: 640px;
  height: 1px;
  margin: 0 auto;
  margin-top: 11px;
  margin-bottom: 7px;

  background: rgba(0, 0, 0, 0.15);
}

.msg {
  /* 孩子性格活泼好动，富有好奇心，表达能力强，但是数学方面能力稍差，有时会混淆九和十的大小，计算功底欠缺，并且经常坐不住。 */
  width: 624px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 16px;
}


.emptyinput {
  /* input-完整/small/default/无/off/off/off/off/off (style) */
  width: 170px;
  height: 24px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(220, 223, 230);
  border-radius:
    4px;
  padding-left: 10px;
}

.answer {
  width: 170px;
  height: 22px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01px;
  text-align: left;
}

.sendtitle {
  /* 联系方式 */
  width: 80px;
  height: 20px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  margin-left: 5px;
}

.fanwei {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  width: 290px;
  transform: translateY(-5px);
}

.fanwei img {
  margin-left: 15px;
  margin-bottom: 12px;
}

.title img {
  width: 18px;
  height: 18px;
  transform: translateY(4px);
}


th {
  width: 40px;
  height: 40px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;


}

table {
  border-collapse: collapse;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  margin-left: 21px;
}



tr {
  border: none;
  width: 40px;
  height: 36px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;

}


.checkbox {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 2px;
  left: 6px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: transparent;
  border: none;
}

.checkbox input:checked+.checkmark {
  background-color: #01A299;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked+.checkmark:after {
  display: block;
}

.checkmark:after {
  left: 5px;
  top: 2px;
  width: 3px;
  height: 6px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

button {
  width: 90px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Tlookstudentjianli.vue